import { animateScroll } from 'react-scroll';
import {EXCEPTION_DICTIONARY} from './constant.js'

export const scrollToBottom = (isSmooth) => {
	if (isSmooth || isSmooth === undefined) {
		setTimeout(() => {
			animateScroll.scrollToBottom({
				containerId: "chat-messages-list",
			});
		}, 200);
	} else {
		animateScroll.scrollToBottom({
			containerId: "chat-messages-list",
			duration: 0,
		});
	}
};

export const isIn = (haystack, needle, offset) => {
	if (!haystack) {
		return false;
	}
	if (typeof haystack === 'object' && !Array.isArray(haystack)) {
		return haystack.hasOwnProperty(needle);
	} else {
		return haystack.indexOf(needle, offset) !== -1;
	}
}

export const removeFromArray = (array, name) => {
	if (!array || !name) {
		return;
	}
	try {
		const idx = array.indexOf(name);
		if (idx !== -1) {
			array.splice(idx, 1);
		}
	} catch (e) {}
}

export const removeFromObject = (object, name) => {
	if (!object || !name) {
		return;
	}
	try {
		delete object[name];
	} catch (e) {}
}

export const checkEmptyInputText = (text) => {
	if (!text) {
		return true;
	}
	return text.replace(/\s+/g, '') === '';
}

export const isDebugEnabled = () => {
	return new URLSearchParams(window.location.search).get("debug_enabled") === '1';
}

export const getDebugLoginUrl = () => {
	if (['DEVELOPMENT', 'STAGING'].includes(getEnvVariable('stage'))) {
		return new URLSearchParams(window.location.search).get("login_url");
	}
	return false;
}

export const isNewConfig = () => {
	return new URLSearchParams(window.location.search).get("new_config") === '1';
}


export const chunkSubstr = (str, size) => {
	const numChunks = Math.ceil(str.length / size);
	const chunks = new Array(numChunks);

	for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
		chunks[i] = str.substr(o, size);
	}

	return chunks;
}

export const prepareQueueName = name => name.split('-').slice(1).join('-')

export const checkExceptionDictionaryQueueName = name => EXCEPTION_DICTIONARY.includes(name)

const envList =  {
	'env': 'ENV',
	'stage': 'STAGE',
	'amazon_api_url': 'AMAZON_API_URL',
	'amazon_api_key': 'AMAZON_API_KEY',
	'cpp_url': 'CCP_URL',
	'login_url': 'LOGIN_URL',
	'amazon_config_storage_url': 'AMAZON_CONFIG_STORAGE_URL',
	'auth0_client_id': 'AUTH0_CLIENT_ID',
	'datadog_client_token': 'DATADOG_CLIENT_TOKEN',
	'amazon_clients_config_url': 'AMAZON_CLIENTS_CONFIG_URL',
}
export const getEnvVariable = (variable) =>{
	const engine = import.meta.env ? 'VITE_' : 'REACT_APP_'

	const envVariable= envList[variable] ?engine+envList[variable] : false
	if (envVariable){
		return import.meta.env ? import.meta.env[envVariable] : process.env[envVariable]
	}
	return false
}
